// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.need-inner-right p {
  color: #fff;
}

.total-tb .mySwiper .swiper-slide {
  background: #fff;
  -webkit-backdrop-filter: blur(30px);
          backdrop-filter: blur(30px);
  border-radius: 0;
  opacity: 1 !important;
  padding: 12px 52px;
  width: auto !important;
  cursor: pointer;
}
.total-tb .mySwiper .swiper-slide h6 {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 19px;
  line-height: 30px;
  color: #55b56d;
  text-align: center;
  margin-bottom: 0;
}
.total-tb .mySwiper .swiper-slide-thumb-active h6 {
  color: #fff;
}
.total-tb .mySwiper .swiper-wrapper {
  width: 89%;
}
/*.our-leads-inner img {
        height: auto;
    }*/
.total-tb .mySwiper .swiper-button-next:after,
.total-tb .swiper-button-prev:after {
  font-size: 25px;
  color: #ffffff;
}
.total-tb .swiper {
  width: 100%;
  height: 100%;
}
.total-tb .swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #fff; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-tb .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.total-tb .swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}
.total-tb .swiper-slide {
  background-size: cover;
  background-position: center;
}
.total-tb .mySwiper2 {
  height: 80%;
  width: 100%;
  padding-left: 10px;
  padding-right: 0;
  margin: 0 auto;
  max-width: 1090px;
}

.active-main-left img {
  max-width: 100%;
}

.total-tb .mySwiper {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}
.total-tb .mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.total-tb .mySwiper2 .swiper-slide {
  width: 104% !important;
  width: 100% !important;
}
.total-tb .mySwiper .swiper-slide-thumb-active {
  opacity: 1;
  background-color: #55b56d;
}
.total-tb .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.total-tb .mySwiper2 .swiper-button-next:after,
.total-tb .swiper-button-prev:after {
  font-size: 25px;
  color: #ffffff;
  background-color: #55b56d;
  padding: 9px 12px;
  border-radius: 0;
}

.have-right ul {
  margin: 0;
}

.have-right ul li img {
  width: 18px;
  margin-right: 10px;
}

.have-right ul {
  padding: 0;
  margin: 0;
}

.have-right ul li {
  line-height: 38px;
  color: #fff;
}

.active-main {
  width: 100%;
  overflow: hidden;
}

.navbar-nav .dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu {
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.dropdown-item {
  color: #333;
}

@media (max-width: 1200px) and(min-width:992px) {
  .total-tb .mySwiper .swiper-slide {
    padding: 12px 24px;
  }
}

.btn-demo {
  background-color: red;
  font-family: 'Poppins';
  padding: 2px 20px;
  color: white;
  font-size: 12px;
  border: none;
  border-radius: 24px;
  margin-left: 10px;
  line-height: 28px;
  margin-top: 17.5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mCAA2B;UAA3B,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;;MAEM;AACN;;EAEE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".need-inner-right p {\r\n  color: #fff;\r\n}\r\n\r\n.total-tb .mySwiper .swiper-slide {\r\n  background: #fff;\r\n  backdrop-filter: blur(30px);\r\n  border-radius: 0;\r\n  opacity: 1 !important;\r\n  padding: 12px 52px;\r\n  width: auto !important;\r\n  cursor: pointer;\r\n}\r\n.total-tb .mySwiper .swiper-slide h6 {\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 19px;\r\n  line-height: 30px;\r\n  color: #55b56d;\r\n  text-align: center;\r\n  margin-bottom: 0;\r\n}\r\n.total-tb .mySwiper .swiper-slide-thumb-active h6 {\r\n  color: #fff;\r\n}\r\n.total-tb .mySwiper .swiper-wrapper {\r\n  width: 89%;\r\n}\r\n/*.our-leads-inner img {\r\n        height: auto;\r\n    }*/\r\n.total-tb .mySwiper .swiper-button-next:after,\r\n.total-tb .swiper-button-prev:after {\r\n  font-size: 25px;\r\n  color: #ffffff;\r\n}\r\n.total-tb .swiper {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.total-tb .swiper-slide {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  /* background: #fff; */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.total-tb .swiper-slide img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n.total-tb .swiper {\r\n  width: 100%;\r\n  height: 300px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n.total-tb .swiper-slide {\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n.total-tb .mySwiper2 {\r\n  height: 80%;\r\n  width: 100%;\r\n  padding-left: 10px;\r\n  padding-right: 0;\r\n  margin: 0 auto;\r\n  max-width: 1090px;\r\n}\r\n\r\n.active-main-left img {\r\n  max-width: 100%;\r\n}\r\n\r\n.total-tb .mySwiper {\r\n  height: 20%;\r\n  box-sizing: border-box;\r\n  padding: 10px 0;\r\n}\r\n.total-tb .mySwiper .swiper-slide {\r\n  width: 25%;\r\n  height: 100%;\r\n  opacity: 0.4;\r\n}\r\n.total-tb .mySwiper2 .swiper-slide {\r\n  width: 104% !important;\r\n  width: 100% !important;\r\n}\r\n.total-tb .mySwiper .swiper-slide-thumb-active {\r\n  opacity: 1;\r\n  background-color: #55b56d;\r\n}\r\n.total-tb .swiper-slide img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: fill;\r\n}\r\n\r\n.total-tb .mySwiper2 .swiper-button-next:after,\r\n.total-tb .swiper-button-prev:after {\r\n  font-size: 25px;\r\n  color: #ffffff;\r\n  background-color: #55b56d;\r\n  padding: 9px 12px;\r\n  border-radius: 0;\r\n}\r\n\r\n.have-right ul {\r\n  margin: 0;\r\n}\r\n\r\n.have-right ul li img {\r\n  width: 18px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.have-right ul {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.have-right ul li {\r\n  line-height: 38px;\r\n  color: #fff;\r\n}\r\n\r\n.active-main {\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.navbar-nav .dropdown:hover .dropdown-menu {\r\n  display: block;\r\n}\r\n\r\n.dropdown-menu {\r\n  background-color: #fff;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.dropdown-item {\r\n  color: #333;\r\n}\r\n\r\n@media (max-width: 1200px) and(min-width:992px) {\r\n  .total-tb .mySwiper .swiper-slide {\r\n    padding: 12px 24px;\r\n  }\r\n}\r\n\r\n.btn-demo {\r\n  background-color: red;\r\n  font-family: 'Poppins';\r\n  padding: 2px 20px;\r\n  color: white;\r\n  font-size: 12px;\r\n  border: none;\r\n  border-radius: 24px;\r\n  margin-left: 10px;\r\n  line-height: 28px;\r\n  margin-top: 17.5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
